import { render, staticRenderFns } from "./yzm.vue?vue&type=template&id=54651bca&scoped=true&"
import script from "./yzm.vue?vue&type=script&lang=js&"
export * from "./yzm.vue?vue&type=script&lang=js&"
import style0 from "./yzm.vue?vue&type=style&index=0&id=54651bca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54651bca",
  null
  
)

export default component.exports